import React, { Component } from 'react'
import { siteContent } from '@services/api'
import { Select, Table, Button, Icon, Input } from 'antd'
import { inject, observer } from 'mobx-react'
import EditSiteContentPopup from '@components/Popup/EditSiteContentPopup'

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
export default class extends Component {
    constructor(props) {
        super(props)
        this.state = {
            lng: null,
            component: null,
            textFilter: '',
            keyFilter: '',
            data: []
        }
        this.handleSetData = this.handleSetData.bind(this)
        this.createDataSource = this.createDataSource.bind(this)
    }

    handleSetData(data) {
        this.setState({
            data: data.map(slot => {
                return { ...slot, keys: JSON.parse(slot.keys) }
            })
        })
    }

    createDataSource() {
        let arr = []
        let { data, lng, component, textFilter, keyFilter } = this.state

        data.map(slot => {
            Object.entries(slot.keys).map(([key, value]) =>
                arr.push({
                    id: slot.id,
                    component: slot.component,
                    lng: slot.lng,
                    key: { key, value },
                    updated_by: slot.updated_by,
                    updated_at: slot.updated_at
                })
            )
        })
        return arr.filter(slot => {
            const { value, key } = slot.key
            return (
                (lng ? slot.lng == lng : true) &&
                (component ? slot.component == component : true) &&
                key.toLowerCase().includes(keyFilter.toLowerCase()) &&
                (slot.component != 'faq_' ? value.includes(textFilter) : `${value.q} ${value.a}`.includes(textFilter))
            )
        })
    }

    componentDidMount() {
        siteContent
            .getSiteContent()
            .then(res => this.handleSetData(res.data))
            .catch(err => console.log(err))
    }

    render() {
        const { lng, component, data } = this.state
        const {
            isDeveloper,
            popupStore: { togglePopup }
        } = this.props

        let columns = [
            {
                title: 'שפה',
                key: 'lng',
                width: 40,
                align: 'center',
                render: (_, record) => <span key={record.lng}>{record.lng}</span>
            },
            {
                title: isDeveloper ? 'מיקום' : 'משותף?',
                key: 'component',
                width: 40,
                align: 'center',
                render: (_, record) => (
                    <span>
                        {isDeveloper ? (
                            record.component.substring(0, record.component.length - 1)
                        ) : (
                            <Icon
                                type={
                                    record.component == '_' || record.component[0] === record.component[0].toLowerCase()
                                        ? 'check'
                                        : 'close'
                                }
                            />
                        )}
                    </span>
                )
            },
            {
                title: 'טקסט',
                key: 'text',
                width: 300,
                align: 'center',
                render: (_, record) => {
                    const { value } = record.key
                    return record.component != 'faq_' ? (
                        <span>{value}</span>
                    ) : (
                        <>
                            <span>{`q: ${value.q}`} </span>
                            <br />
                            <span> {`a: ${value.a}`}</span>
                        </>
                    )
                }
            },
            {
                title: '',
                key: 'edit',
                width: 50,
                align: 'right',
                render: (_, record) => {
                    return (
                        <Button
                            onClick={() => {
                                togglePopup('editSiteContent', {
                                    ...record,
                                    handleSetData: this.handleSetData
                                })
                            }}
                        >
                            <Icon type="edit" />
                        </Button>
                    )
                }
            }
        ]
        isDeveloper &&
            columns.unshift({
                title: 'מפתח',
                key: 'key',
                width: 40,
                align: 'center',
                render: (_, record) => <span>{record.component != 'faq_' ? record.key.key : 'faq'}</span>
            })

        return (
            <div style={{ flexDirection: 'column' }}>
                <div style={{ flexDirection: 'column' }}>
                    <div style={{ flexDirection: 'row' }}>
                        <Select
                            id="set_lng"
                            value={lng}
                            style={{ width: '50%' }}
                            placeholder="בחר שפה"
                            onChange={lng => this.setState({ lng })}
                        >
                            <Select.Option value={null} key={'empty'}>
                                כל השפות
                            </Select.Option>
                            {[...new Set(data.map(slot => slot.lng))].map(slot => (
                                <Select.Option value={slot} key={slot}>
                                    {slot}
                                </Select.Option>
                            ))}
                        </Select>
                        {isDeveloper ? (
                            <Select
                                id="set_component"
                                value={component}
                                style={{ width: '50%' }}
                                placeholder="בחר מיקום"
                                onChange={component => this.setState({ component })}
                            >
                                <Select.Option value={null} key={'empty'}>
                                    כל המיקומים
                                </Select.Option>
                                {[
                                    ...new Set(
                                        data.map(slot => {
                                            return {
                                                component: slot.component,
                                                updated_at: slot.updated_at,
                                                updated_by: slot.updated_by
                                            }
                                        })
                                    )
                                ]
                                    .sort((a, b) => +(a.component > b.component) * 2 - 1)
                                    .map(({ component, updated_by, updated_at }) => (
                                        <Select.Option value={component} key={component}>
                                            {component == '_' ? 'משותף' : component.substring(0, component.length - 1)}
                                            {updated_by && `- עודכן ע"י ${updated_by} - ${updated_at}`}
                                        </Select.Option>
                                    ))}
                            </Select>
                        ) : (
                            ''
                        )}
                        <Input
                            value={this.state.textFilter}
                            placeholder="לפי טקסט"
                            onChange={e => this.setState({ textFilter: e.target.value })}
                            style={{ width: '50%' }}
                        />
                        {isDeveloper ? (
                            <Input
                                value={this.state.keyFilter}
                                placeholder="לפי מפתח"
                                onChange={e => this.setState({ keyFilter: e.target.value })}
                                style={{ width: '50%' }}
                            />
                        ) : (
                            ''
                        )}
                    </div>
                </div>
                <h5 style={{ color: 'red', alignSelf: 'end', marginTop: 5 }}>
                    נא לא לשנות סימון $ ואת האות הצמודה אליו!!!
                </h5>
                <Table
                    rowKey={_ => (_.component != 'faq_' ? _.key.value : `${_.key.value.q}${_.key.value.a}`)}
                    dataSource={this.createDataSource()}
                    columns={columns}
                />
                <EditSiteContentPopup />
            </div>
        )
    }
}
